<template>
  <div class="Register">

    <Head :lanshow="ActiveName" :title="$tc('header.back')" />
    <!-- <NavBar /> -->
    <h5 class="mianbaoxie">
      <span>当前位置：</span><span>首页 </span><span> > 登录页</span>
    </h5>
    <div class="Registers">
      <div class="Register-title">
        <span>网民注册</span><span class="xiahuaxian"></span>
      </div>
      <div class="Register-content">
        <van-form @submit="onSubmit" @failed="onFailed" ref="loginForm">
          <van-cell-group class="form_filed">
            <div class="xinhao"><span>*</span><span class="jianju">账号</span></div>
            <van-field class="biaoge1" v-model="formList.username" name="账号" placeholder="支持中英文、数字，不超过10个字" maxlength="10" :rules="[
                { required: true, message: '必填' },
                { pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/, message: '格式不正确' },
              ]" />
          </van-cell-group>
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">密码</span></div>
            <van-field class="biaoge1" v-model="formList.password" type="password" name="密码" placeholder="请输入8位密码，支持英文、数字" maxlength="8" :rules="[
                { required: true, message: '必填' },
                { pattern: /^[a-zA-Z0-9]{8}/, message: '格式不正确' },
              ]" />
          </van-cell-group>
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">确认密码</span></div>

            <van-field class="biaoge1" v-model="formList.passwordVerify" type="password" name="确认密码" placeholder="请输入8位密码，支持英文、数字" maxlength="8" :rules="[
                { required: true, message: '必填' },
                { pattern: /^[a-zA-Z0-9]{8}/, message: '格式不正确' },
                { validator: asValidator, message: '输入不一致' },
              ]" />
          </van-cell-group>
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">姓名(真实姓名)</span></div>

            <van-field class="biaoge1" v-model="formList.name" name="姓名" maxlength="10" placeholder="填写本人真实姓名，支持中英文，不超过10个字" :rules="[
                { required: true, message: '必填' },
                { pattern: /^[A-Za-z0-9\u4E00-\u9FA5]+$/, message: '格式不正确' },
              ]" />
          </van-cell-group>
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">手机号</span></div>

            <van-field class="biaoge1" v-model="formList.phone" name=" phone" placeholder="请输入11位手机号" maxlength="11" :rules="[
                { required: true, message: '必填' },
                { pattern: /^\d{11}$/, message: '格式不正确' },
              ]" />
          </van-cell-group>
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">验证码</span></div>

            <div class="yanzhen">
              <div>
                <van-field class="biaoge1" v-model="formList.code" name="code" type="number" placeholder="请输入验证码" maxlength="6" :rules="[{ required: true, message: '必填' }]">
                </van-field>
              </div>
              <div class="daojishi">
                <!-- 倒计时 -->
                <van-count-down :time="time" format="ss s" v-if="isCountDownShow" @finish="isCountDownShow = false" />
                <!-- 验证码 -->
                <van-button v-else @click="onSendSms" native-type="button" class="send-code-btn" round size="mini" type="default">
                  获取验证码
                </van-button>
              </div>
            </div>
          </van-cell-group>
          <!-- 性别 -->
          <van-cell-group class="gender_radio">
            <div class="xinhao"><span>*</span><span class="jianju">性别</span></div>
            <van-field v-model="formList.gender" show-error='false' :rules="[{required:true,message:'必填'}]">
              <template #input>

                <span class="xingbieanniu" native-type="button" :class="formList.gender === '0' && 'xingbieanniudianji'" @click="formList.gender = '0'" @change="genderChange(0)">男</span>
                <span class="xingbieanniu" native-type="button" :class="formList.gender === '1' && 'xingbieanniudianji'" @click="formList.gender = '1'" @change="genderChange(1)">女</span>
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">电子邮箱</span></div>

            <van-field v-model="formList.email" name="电子邮箱" placeholder="请输入正确邮箱" maxlength="50" :rules="[
                {
                  required: true,
                  message: '必填',
                },
                {
                  pattern:
                    /@/,
                  message: '电子邮箱格式错误',
                },
              ]" />

          </van-cell-group>
          <!-- 所处地域 -->
          <!-- <van-cell-group>
            <div class="xinhao">
              <span>*</span><span class="jianju">所处地域</span><span>（所在地 / 服务地）</span>
            </div>
            <div class="van-cell van-field van-field--error">

              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select required
                          name=""
                          style="
                      width: 40%;
                      height: 7.8vw;
                      border: 2px solid rgba(0, 0, 0, 0.15);
                      border-radius: 1vw;
                    "
                          v-model="formList.provinceCode"
                          @change="provinceChange"
                          @blur="provinceBlur">
                    <option :value="item.id"
                            v-for="(item, i) in areaList.province_list"
                            :key="i">
                      {{ item.name }}
                    </option>
                  </select>
                  <span style="margin-right: 2vw">省</span>
                  <select required
                          @blur="provinceBlur"
                          name=""
                          id="select2"
                          style="
                      width: 40%;
                      height: 7.8vw;
                      border: 2px solid rgba(0, 0, 0, 0.15);
                      border-radius: 1vw;
                    "
                          v-model="formList.cityCode"
                          :disabled="formList.provinceCode == ''">
                    <option :value="item.id"
                            v-for="(item, i) in areaList.city_list"
                            :key="i">
                      {{ item.name }}
                    </option>
                  </select>
                  <span>市</span>
                </div>
                <div class="van-field__error-message"
                     v-if="bitain">
                  必填
                </div>
              </div>
            </div>
          </van-cell-group> -->
          <!-- 所处地域 -->
          <van-cell-group>
            <div class="xinhao"><span>*</span><span class="jianju">所处地域<span class="xinhao_jianju">（所在地 / 服务地）</span></span></div>
            <div class="van-cell van-field noBorder">
              <van-field style="margin-right: 2vw" readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="
                    formList.province_code.province
                      ? province_list.find(
                          (v) => v.id / 1 === formList.province_code.province
                        ).name
                      : ''
                  " placeholder="点击选择省" @click="pikerShow.province_code__province = true">
                <template #button>
                  <span style="color: rgba(102, 102, 102, 1)">省</span>
                </template>
              </van-field>
              <van-field style="margin-right: 2vw" readonly clickable :rules="[  { required: true, message: '必填' },]" name="picker" :value="
                    formList.province_code.city
                      ? city_list.find(
                          (v) => v.id / 1 === formList.province_code.city
                        ).name
                      : ''
                  " placeholder="点击选择市" @click="
                    formList.province_code.province &&
                      (pikerShow.province_code__city = true)
                  ">
                <template #button>
                  <span style="color: rgba(102, 102, 102, 1)">市</span>
                </template>
              </van-field>
              <van-field style="margin-right: 2vw" readonly clickable :rules="[  { required: true, message: '必填' },]" name="picker" :value="
                    formList.province_code.county
                      ? county_list.find(
                          (v) => v.id / 1 === formList.province_code.county
                        ).name
                      : ''
                  " placeholder="点击选择区/县" @click="
                    formList.province_code.city &&
                      (pikerShow.province_code__county = true)
                  ">
                <template #button>
                  <span style="color: rgba(102, 102, 102, 1)">区/县</span>
                </template>
              </van-field>
              <van-popup v-model="pikerShow.province_code__province" position="bottom">
                <van-picker value-key="name" show-toolbar :columns="province_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(
                          value,
                          'province_code__province',
                          'province_code__city',
                          '1'
                        )
                    " @cancel="pikerShow.province_code__province = false" />
              </van-popup>
              <van-popup v-model="pikerShow.province_code__city" position="bottom">
                <van-picker value-key="name" show-toolbar :columns="city_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__city', '', '2')
                    " @cancel="pikerShow.province_code__city = false" />
              </van-popup>
              <van-popup v-model="pikerShow.province_code__county" position="bottom">
                <van-picker value-key="name" show-toolbar :columns="county_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__county', '', '3')
                    " @cancel="pikerShow.province_code__county = false" />
              </van-popup>
            </div>
          </van-cell-group>
          <!-- 所处地域 -->

          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaLists" @confirm="onConfirm" @cancel="showArea = false" />
          </van-popup>
          <div style="margin: 16px">
            <van-button round block type="info" native-type="submit">提交</van-button>
          </div>
          <div style="margin: 16px" class="quxiaoanniu">
            <van-button round block type="default" native-type="button" @click="resetLoginForm">取消</van-button>
          </div>
        </van-form>
        <!-- 登陆成功弹层 -->
        <van-popup v-model="show" @close="quxiao" closeable close-icon="cross" :style="{ height: '50%', width: '90%' }" :close-on-click-overlay="false" round>
          <div class="chenggong">
            <div class="chenggong-title">提示</div>
            <div class="chenggong-content">
              <div class="chenggong-content-toast">
                <img src="@/assets/img/成功@3x.png" alt="" style="width: 5.53vw;" />
                <span>注册成功</span>
              </div>
              <van-button class="chegngong-btn chegngong-btn-bgc" size="small" type="info" @click="toHome">去举报</van-button>
              <van-button class="chegngong-btn " size="small" type="info" native-type="button" @click="toAuthentication">认证成为义务监督员</van-button>
              <van-button class="chegngong-btn " size="small" type="info" native-type="button" @click="toVolunteerCertification">认证成为志愿者</van-button>
            </div>
          </div>
        </van-popup>
        <!-- 邀请码弹框 -->
        <van-dialog v-model="InvitationCode" title="邀请码" show-cancel-button clickable @cancel="quxiao" @confirm="queren(querenState)">
          <van-field v-model="Invitation" placeholder="邀请码" />
        </van-dialog>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { areaLists } from '@/utils/areaLists.js'
import { encrypt } from '@/utils/security'

export default {
  name: 'Register',
  props: {},
  data () {
    return {
      pikerShow: {
        province_code__province: false,
        province_code__city: false,
        province_code__county: false,
        native_place__province1: false,
        native_place__city1: false
      },
      radio: '',
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      bitain: false,
      ismust: false,
      Invitation: '',
      InvitationCode: false,
      querenState: '',
      show: false,
      time: 60 * 1000,
      isCountDownShow: false,
      areaLists,
      value: '',
      showArea: false,
      formList: {
        username: '', // 账号
        password: '', // 密码
        passwordVerify: '', // 确认密码
        name: '', // 姓名
        phone: '', // 手机号
        code: '', // 验证码
        gender: '', // 性别
        email: '', // 电子邮箱
        provinceCode: '', // 所在地域-省编码
        cityCode: '', // 所在地域-市编码
        countyCode:'',
        province_code: { province: '', city: '',county:'' }// 所在地域
      },
      province_list: [],
      city_list: [],
      county_list: [],
      areaList: {
        province_list: [],
        city_list: [],
        county_list: [],
        ReportingPlatform: [
          { Platform: '请选择' },
          { Platform: '网站网页' },
          { Platform: 'App' },
          { Platform: '网络账号' }
        ],
        appPlatform: [
          { Platform: '请选择' },
          { Platform: '有害信息链接' },
          { Platform: 'App官方网址' },
          { Platform: 'App下载地址' }
        ],
        app: [
          { Platform: '请选择' },
          {
            Platform: '微信',
            nature: [
              { Platform: '个人' },
              { Platform: '公众' },
              { Platform: '群组' }
            ]
          },
          {
            Platform: 'QQ',
            nature: [{ Platform: '个人' }, { Platform: '群组' }]
          },
          {
            Platform: '微博',
            nature: [{ Platform: '认证' }, { Platform: '非认证' }]
          },
          {
            Platform: '贴吧'
          },
          {
            Platform: '博客'
          },
          {
            Platform: '直播平台'
          },
          {
            Platform: '论坛社区'
          },
          {
            Platform: '网盘'
          },
          {
            Platform: '音频'
          },
          {
            Platform: '其他'
          }
        ],
        weixin: [
          { Platform: '个人' },
          { Platform: '公众' },
          { Platform: '群组' }
        ]
      }
    }
  },
  created () {
    this.setShowLoading(false)
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
    // areaList市区联动查询
    this.$Api.areaList({ type: '1', parentId: '1' }).then((res) => {
      this.province_list = res.list
      this.areaList.province_list = res.list
    })
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName', 'setActiveName']),
    onConfirmCity (value, filed, clearFiled, type) {
      this.pikerShow[filed] = false
      this.formList[filed.split('__')[0]][filed.split('__')[1]] = value.id
      console.log(this.formList)
      // if (clearFiled) {
      //   this.formList[clearFiled.split('__')[0]][clearFiled.split('__')[1]] =
      //     ''
      // }
      // if (type === '1' || type === '3') {
      //   type === '1' && (this.city_list = [])
      //   type === '3' && (this.areaList.city_list = [])
      //   this.$Api.areaList({ type: '2', parentId: value.id }).then((res) => {
      //     type === '1' && (this.city_list = res.list)
      //     type === '3' && (this.areaList.city_list = res.list)
      //   })
      // }
      if(type === '1'){
        this.formList.province_code.city = ''
        this.formList.province_code.county = ''
        this.$Api.areaList({ type:2, parentId: value.id }).then((res) => {
          this.city_list = res.list
        })
      }else if(type === '2'){
        this.formList.province_code.county = ''
        this.$Api.areaList({ type:3, parentId: value.id }).then((res) => {
          this.county_list = res.list
        })
      }
      
    },
    provinceChange () {
      this.areaList.city_list = []
      this.$Api
        .areaList({ type: '2', parentId: this.formList.provinceCode })
        .then((res) => {
          this.areaList.city_list = res.list
        })
    },
    provinceBlur () {
      this.bitain = this.formList.cityCode == ''
    },
    async onSubmit () {
      if (this.formList.gender == '') {
        return (this.ismust = true)
      }
      try {
        await this.$refs.loginForm.validate()
        const {
          username,
          password,
          passwordVerify,
          name,
          phone,
          code,
          gender,
          email,
          coemailde
          // provinceCode,
          // cityCode
        } = this.formList
        this.$Api
          .userRegister({
            username,
            password: encrypt(password),
            passwordVerify: encrypt(passwordVerify),
            name,
            phone: encrypt(phone),
            code: encrypt(code),
            gender,
            email,
            coemailde,
            provinceCode: this.formList.province_code.province,
            cityCode: this.formList.province_code.city,
            countyCode: this.formList.province_code.county
          }, {
            callback: (res) => {
              if (res.status !== 0 && !res.data) {
                this.$toast(res.message)
              } else if (res.status !== 0 && res.data) {
                this.$dialog
                  .alert({
                    title: '提示',
                    message: `该手机号已有账号${res.data.username},请直接登录`
                  })
                  .then(() => {
                    // on close
                  })
              }
            },
            noToast: true
          })
          .then((res) => {
            console.dir(res)
            if (!res) return

            // 显示注册成功弹层
            this.showPopup()
          })
          .catch()
      } catch (error) { }
    },
    onFailed () {
      this.$toast('还有必填项未完成')
    },
    asValidator () {
      return this.formList.password == this.formList.passwordVerify
    },
    genderChange (type) {
      if (type == 0 || type == 1) {

      } else {
        this.ismust = true
      }
    },
    resetLoginForm () {
      this.$dialog.confirm({
        title: '提示',
        message: '当前页面未完成，确认离开吗？离开后内容将不会保存。'
      }).then(() => {
        // 返回登录页
        // const path = { path: '/login' }
        if (window.history.length <= 1 || this.hisLen <= 1) {
          this.$router.replace({
            path: '/login',
            query: {
              lan: this.lang
            }
          })
        } else {
          this.$router.back()
        }
      }).catch()
    },
    onConfirm (values) {
      this.formList.provinceCode = values[0].code
      this.formList.cityCode = values[1].code
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('---')
      this.showArea = false
    },
    // 验证码点击注册
    async onSendSms () {
      const r = /\d{11}/
      if (!r.test(this.formList.phone)) return
      // 验证通过显示倒计时
      this.isCountDownShow = true
      // 请求发送验证码
      try {
        await this.$Api.sendCode({
          phone: encrypt(this.formList.phone)
        })
        this.$toast('发送成功')
      } catch (err) {
        this.isCountDownShow = false
      }
    },
    showPopup () {
      this.show = true
    },
    toHome () {
      // 登录
      this.$Api
        .userLogin({
          username: this.formList.username,
          password: encrypt(this.formList.password)
        }).then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res))
          // 登陆状态
          this.setActiveName(true)
          // 已登录后进行跳转
          this.$router.push('/')
        })
    },
    toAuthentication () {
      this.InvitationCode = true
      this.querenState = 1
    },
    toVolunteerCertification () {
      this.InvitationCode = true
      this.querenState = 2
    },
    queren (state) {
      // 判断邀请码是否正确

      this.$Api.inviteCheck({
        inviteCode: encrypt(this.Invitation),
        inviteType: state
      }, { noToast: false }).then(() => {
        // 登录
        this.$Api
          .userLogin({
            username: this.formList.username,
            password: encrypt(this.formList.password)
          }).then(res => {
            this.Invitation = ''
            localStorage.setItem('userInfo', JSON.stringify(res))
            // 登陆状态
            this.setActiveName(true)
            // 已登录后进行跳转
            this.$router.push({ path: '/authentication', query: { isVolunteerCertification: state, inviteCode: encrypt(this.Invitation) } })
          })
      }).catch(() => {
        this.Invitation = ''
      })
    },
    quxiao () {
      // 登录
      this.$Api
        .userLogin({
          username: this.formList.username,
          password: encrypt(this.formList.password)
        }).then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res))
          // 登陆状态
          this.setActiveName(true)
          // 已登录后进行跳转
          this.$router.push('/personal')
        })
    }
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  watch: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.Register {
  .Registers {
    padding: 4vw;
    .Register-title {
      position: relative;
      text-align: center;
      font-size: 6vw;
      font-weight: 700;
      margin-bottom: 6vw;
      .xiahuaxian {
        position: absolute;
        top: 7vw;
        left: 42vw;
        width: 6vw;
        height: 1vw;
        border-bottom: 1.3vw solid #0852c8;
      }
    }
  }
}
.chenggong {
  padding: 2vw;
  font-size: 4.8vw;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
}
.chenggong-title {
  padding: 2vw;
}
.chenggong-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .chenggong-content-toast {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 9vw 0;
  }
}
.chegngong-btn {
  margin-top: 2vw;
  width: 80vw;
  height: 10.66vw;
  font-size: 4.26vw;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #002fa7;
  background-color: #fff;
  &:hover {
    background-color: #002fa7;
    color: #fff;
  }
}
.chegngong-btn-bgc {
  background-color: #002fa7;
  color: #fff;
}
.xinhao {
  display: flex;
  // justify-content: center;
  align-items: center;
  span {
    font-size: 4.26vw;
    font-weight: 700;
    color: #666666;
  }
  :first-child {
    color: red;
  }
}
.biaoge {
  width: 45%;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
}
// .biaoge1 {
//   width: 100%;
//   height: 8vw;
//   border: 2px solid rgba(0, 0, 0, 0.15);
// }
.xingbieanniu {
  text-align: center;
  line-height: 9vw;
  background: #f6f8fa;
  margin: 0vw 2vw;
  padding: 1.9vw 12vw;
}
.xingbieanniudianji {
  font-weight: bold;
  color: #002fa7;
  background: #e9f1ff;
  border: 1px solid #002fa7;
}
.yanzhen {
  display: flex;
  justify-content: space-between;
  :nth-child(1) {
    flex: 1;
  }
}
.ismust {
  text-align: left;
  color: red;
}
.xinhao_jianju {
  font-size: 3.73vw !important;
  font-family: MicrosoftYaHei;
  color: #999990 !important;
}
</style>
